import { Link } from "react-router-dom";
import { fmt } from "@/shop/api";

export default function ProductCard({ p, big = false }) {
  const sold = p.sold;
  const imgs = p.images || [];
  const img = imgs[0]?.url || "/photos/tre-canne.jpg";
  const alt = imgs[0]?.alt || p.name;
  const studio = p.product_type === "selected_tackle" && !!imgs[0]?.url;
  const path =
    p.product_type === "archive"
      ? `/shop/archive/${p.slug}`
      : p.product_type === "edition"
        ? `/shop/editions/${p.slug}`
        : `/shop/selected-tackle${p.brand_slug ? `/${p.brand_slug}` : ""}/${p.slug}`;

  return (
    <Link
      to={path}
      data-testid={`product-card-${p.sku}`}
      className="group flex flex-col h-full border border-ink-border bg-ink overflow-hidden hover:border-faint transition-colors duration-500"
    >
      <div className={`relative overflow-hidden ${big ? "aspect-[4/3]" : "aspect-[4/5]"} ${studio ? "bg-bone" : ""}`}>
        <img
          src={img}
          alt={alt}
          loading="lazy"
          className={`h-full w-full transition-all duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05] ${
            studio ? "object-contain mix-blend-multiply p-3" : "object-cover"
          } ${sold ? "opacity-75 saturate-[0.6]" : ""}`}
        />
        {sold && (
          <span
            data-testid={`sold-stamp-${p.sku}`}
            className="absolute top-4 right-4 font-mono text-[10px] tracking-[0.3em] text-ember border border-ember px-2.5 py-1 bg-ink/70 backdrop-blur-sm"
          >
            SOLD
          </span>
        )}
        {!sold && p.low_stock && (
          <span className="absolute top-4 right-4 font-mono text-[9px] tracking-[0.25em] text-bone/90 border border-bone/30 px-2.5 py-1 bg-ink/70 backdrop-blur-sm">
            ULTIMI PEZZI
          </span>
        )}
        {p.preorder && !p.sold_out && (
          <span className="absolute top-4 right-4 font-mono text-[9px] tracking-[0.25em] text-bone border border-bone/30 px-2.5 py-1 bg-ink/70 backdrop-blur-sm">
            PREORDINE
          </span>
        )}
      </div>
      <div className="flex flex-col flex-1 p-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-faint">
          {p.brand || p.manufacturer}
        </p>
        <h3
          className={`mt-2 font-serif font-light tracking-tight leading-snug group-hover:text-ember transition-colors duration-500 ${
            big ? "text-2xl md:text-3xl" : "text-lg md:text-xl"
          }`}
        >
          {p.name}
        </h3>
        <div className="mt-auto pt-4 flex items-center justify-between">
          <span className="font-mono text-sm text-bone">{fmt(p.price)}</span>
          {p.product_type === "edition" && p.edition_of && (
            <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-faint">
              {p.edition_of}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
